import {BRAND_NAME} from "../constants/company";

export const concatWithBrandName = (value: string, suffix: string = "") => `${value} ${BRAND_NAME}${suffix}`;
import {BRAND_NAME} from "../constants/company";

export const concatWithBrandName = (value: string, suffix: string = "") => `${value} ${BRAND_NAME}${suffix}`;
